export default __webpack_public_path__ + "locales/pt/Webhooks.json?hash=20a9d5dd63b5db084d54ef0083eabab0";